import { Component, ViewEncapsulation, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';

import { Analytics } from 'src/providers/analytics/analytics';
import { BookJob } from 'src/providers/book-job/book-job';
import { Client } from 'src/providers/client/client';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { Pros } from 'src/providers/pros/pros';
import { Schedule } from 'src/providers/schedule/schedule';
import { Addresses } from "src/providers/customer/addresses";
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { WindowService } from 'src/shared/providers/window.service';
import { Requests } from 'src/providers/requests/requests';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { TimeRanges } from 'src/providers/time-ranges/time-ranges';
import { OnboardingProvider } from 'src/providers/onboarding/onboarding.provider';

import { Util } from 'src/shared/util/util';
import validationUtils from 'src/shared/util/validation-utils';
import { parsePhoneNumber } from 'src/tidy-ui-components/components/form/input-international-phone/international-number.utils';

import { ConfirmPage, ConfirmPageParamsModel } from 'src/pages/confirm/confirm.component';

import { TidySelectStringValueModel } from 'src/models/tidy-select-item.model';

import { TranslationPipe } from 'src/shared/pipes/translation.pipe';

import { DateTime as LuxonDateTime, Duration } from 'luxon';
import { AddCreditCardToBookComponent } from 'src/pages/add-credit-card-to-book/add-credit-card-to-book.component';
import { Card } from 'src/providers/card/card';

@Component({
  templateUrl: 'select-category.html',
  styleUrls: ['./select-category.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})

export class SelectCategoryPage implements OnInit {

  addProForm: UntypedFormGroup;
  addresses: any;
  allCategories: any;
  allFrequencyItems = [
    { value: 'once', viewValue: new TranslationPipe().transform('One Time') },
    { value: 'every_four_weeks', viewValue: new TranslationPipe().transform('Every 4 Weeks') },
    { value: 'every_other_week', viewValue: new TranslationPipe().transform('Every 2 Weeks') },
    { value: 'every_week', viewValue: new TranslationPipe().transform('Weekly') },
    { value: 'twice_a_week', viewValue: new TranslationPipe().transform('2x Per Week') },
    { value: 'thrice_a_week', viewValue: new TranslationPipe().transform('3x Per Week') },
    { value: 'every_day', viewValue: new TranslationPipe().transform('Every Day') }
  ]
  allTimesOpts: TidySelectStringValueModel[];
  assignJobTimeItems: any;
  attachments: any = [];
  availabilityRequestTimeItems: any;
  bookingId: any;
  bookingType: any;
  categories: any;
  categoryId: any;
  countryCode: string;
  currentDateTime: any;
  date: any;
  dialogParams: any;
  didChooseFrequency: boolean;
  didSelectAllTimes: boolean;
  @ViewChild('dynamicBookingForm') dynamicBookingForm: any;
  errorMessage: string;
  firstJobDateLabel = new TranslationPipe().transform('Job date');
  firstJobTimeLabel = new TranslationPipe().transform('Job time');
  form: UntypedFormGroup;
  forms: any;
  frequencyItems = this.allFrequencyItems;
  frequencyName: string;
  hasImageUploadError = false;
  hasPrivatePros: boolean;
  howToBookItems: any;
  isAddingPro: boolean;
  isFindingPro: boolean;
  isLoadingDynamicForm = false;
  isLoadingTimes: boolean;
  isRentalClient: boolean;
  isRescheduling: any;
  isRightSideContent = true;
  newBookingId: any;
  @ViewChild('noEarlierDate') noEarlierDate: any;
  noEarlierTimes: TidySelectStringValueModel[];
  noLaterTimes: TidySelectStringValueModel[];
  notSelectedTimesError: boolean;
  originalJobData: any;
  pageTitle: string;
  params: any;
  planId: any;
  priorityListSentence: any;
  probabilityData: any;
  proItems: any;
  propertyItems: any;
  prosData: any;
  proServiceItems: any;
  requestableDays: any;
  scenario: any;
  searchForm: UntypedFormGroup;
  selectedAddress: any;
  selectedCheckboxes: any = [];
  selectedFrequency: string;
  selectedPro: any;
  selectedService: any;
  selectedServiceType: any;
  selectedTab = 'assign';
  selectedTimes: any;
  service: any;
  services: any;
  serviceTypeItems: any;
  showAllDays = false;
  showLoader: boolean;
  showMoreServices: boolean;
  showPageLoader = true;
  showProChangeLoader: boolean;
  showSameDayTimeAlert: boolean;
  showServiceChangeLoader: boolean;
  showTimesError: boolean;
  shownPros: any;
  submitted: boolean;
  selectTimesTitle;
  timeOpts: any;
  timeRangeForms: any;
  timesErrorText: string;
  todayAvailabilityRequesTimeItems: any;
  tooFarStartDateError: boolean;
  weekDayCheckBox: any;
  unableToRequestJob: boolean;
  backPage = 'schedule';
  private hasTrackedInitiateCheckout = false;

  boundAddNewPro = this.addNewPro.bind(this);
  boundChangeServiceRates = this.changeServiceRates.bind(this);
  boundSubmitForm = this.submitForm.bind(this);

constructor(
    private addressProvider: Addresses,
    private analytics: Analytics,
    private bookJobService: BookJob,
    private changeDetectorRef: ChangeDetectorRef,
    private client: Client,
    private fb: UntypedFormBuilder,
    private modalCtrl: ModalController,
    private navCtrl: CustomNavController,
    private prosService: Pros,
    private requests: Requests,
    private rightSidePanelService: RightSidePanelService,
    private schedule: Schedule,
    private storage: TidyStorage,
    private timeRanges: TimeRanges,
    private util: Util,
    public windowService: WindowService,
    private onboardingProvider: OnboardingProvider,
    private card: Card
  ) {
    this.form = this.fb.group({
      address: ['', Validators.required],
      serviceType: [''],
      jobDate: [''],
      jobTime: [''],
      jobSecondDate: [''],
      jobSecondTime: [''],
      jobThirdDate: [''],
      jobThirdTime: [''],
      pro: [''],
      service: [''],
      frequency: ['once'],
      jobNote: [''],
      noEarlierDate: ['', Validators.required],
      noEarlierTime: ['', Validators.required],
      noLaterDate: ['', Validators.required],
      noLaterTime: ['', Validators.required],
      newProName: ['', Validators.required],
      newProEmail: ['', [Validators.required, validationUtils.validateEmail]],
      newProPhone: ['', [Validators.minLength(10)]],
      serviceCategories: ['']
    });
    this.weekDayCheckBox = Array(28).fill(null).map(() => this.fb.group({
      checked: false
    }));
    this.timeRangeForms = Array(28).fill(null).map(() => []);
    this.requestableDays = this.client.requestableDates();
    this.assignJobTimeItems = this.bookJobService.getJobTimeItems();
  }

  async ngOnInit() {
    this.isRightSideContent = await this.storage.retrieve('dialog-right-side-open') || false;
    this.backPage = await this.storage.retrieve('bookJobBackPage') || 'schedule';
    try {
      this.showPageLoader = true;
      localStorage.setItem('select-category-opened', 'true');
      await this.loadParams();
      await this.loadPropertyItems();
      await this.loadServiceTypeItems();
      await this.patchInitialFormValues();
      await this.getProItems();
      if (this.isRescheduling && this.originalJobData) {
        await this.handleReschedulingPreFill();
      }
      this.buildRequestJobTimes();
      await this.selectInitialProAndTab();
      this.showPageLoader = false;
      this.form.controls.serviceType.updateValueAndValidity();

      // Track initiate_checkout for rentals when they see the job request form
      await this.trackInitiateCheckoutForRentals();
    } catch(_err) {
      this.showIssueLoadingPageAlert();
    }
  }

  private async trackInitiateCheckoutForRentals() {
    // Only fire once, only for rentals in request tab, only for real accounts, only on first booking
    if (this.hasTrackedInitiateCheckout || !this.isRentalClient || this.selectedTab !== 'request') {
      return;
    }
    const isGuestAccount = await this.storage.retrieve('isGuestAccount');
    const isFirstBooking = await this.storage.retrieve('isFirstBooking');
    if (!isGuestAccount && isFirstBooking) {
      this.analytics.trackInitiateCheckout();
      this.hasTrackedInitiateCheckout = true;
    }
  }

  async loadParams() {
    this.hasPrivatePros = await this.prosService.checkIfHasPrivatePro();
    this.dialogParams = await this.storage.retrieve('dialog-params');
    this.bookJobService.clearBookJobStorage();
    this.isFindingPro = this.navCtrl.getParam('isFindingPro') || this.dialogParams?.isFindingPro;
    this.isRentalClient = localStorage.getItem('isRentalClient') === 'true';
    this.bookingType = this.navCtrl.getParam('bookingType') || this.dialogParams?.bookingType;
    this.categoryId = this.navCtrl.getParam('categoryId') || this.dialogParams?.categoryId;
    this.bookingId = this.navCtrl.getParam('bookingId') || this.dialogParams?.bookingId;
    this.planId = this.navCtrl.getParam('planId') || this.dialogParams?.planId;
    this.date = this.navCtrl.getParam('date') || this.dialogParams?.date;
    this.isRescheduling = this.navCtrl.getParam('isRescheduling') || this.dialogParams?.isRescheduling;
    this.originalJobData = this.navCtrl.getParam('originalJobData') || this.dialogParams?.originalJobData;
    this.pageTitle = this.getPageTitle();
    this.rightSidePanelService.setDialogPageTitle(this.pageTitle);
  }

  getPageTitle() {
    if (this.bookingType === 'reschedule_job') {
      return 'Reschedule';
    } else if (this.bookingType === 'reschedule_plan') {
      return 'Reschedule Plan';
    } else if (this.isFindingPro) {
      return 'Find New Pro';
    } else {
      return 'Add Job';
    }
  }

  async loadPropertyItems() {
    this.addresses = await this.client.getMoreDetailAddresses();
    this.propertyItems = [];
    this.addresses.map((address) => {
      this.propertyItems.push({
        viewValue: address.address_name ? address.address_name : address.address1,
        value: address.id
      });
    });
  }

  async loadServiceTypeItems() {
    const categories = await this.prosService.getServiceCategories();
    this.serviceTypeItems = categories.map((category) => ({
        ...category,
        icon: category.icon_url,
        viewValue: new TranslationPipe().transform(category.name === 'Regular Cleaning' ? 'Cleaning' : category.name),
        value: category.id
      }));
    this.selectedServiceType = this.serviceTypeItems[0];
  }

  async patchInitialFormValues() {
    const addressId = await this.client.getSelectedAddressId(this.addresses);
    this.form.patchValue({address: addressId});
    const address = this.addresses.find((addr) => addr.id === addressId);
    this.selectedAddress = address;
    this.currentDateTime = LuxonDateTime.fromObject({}, {
      zone: this.selectedAddress.timezone,
    });
    if (this.categoryId) {
      this.form.patchValue({serviceType: this.categoryId});
    } else {
      this.form.patchValue({serviceType: this.serviceTypeItems[0].value});
    }
    this.selectedServiceType = this.serviceTypeItems.find((serviceType) => serviceType.value === this.form.value.serviceType);
    const now = LuxonDateTime.now();
    this.form.patchValue({
      jobDate: this.date ? LuxonDateTime.fromFormat(this.date, "MM-dd-yyyy").toISO() : now.plus({days: 1}).toISO(),
      jobTime: '11:00',
      jobSecondTime: '11:00',
      jobThirdTime: '11:00',
      noEarlierDate: this.date ? LuxonDateTime.fromFormat(this.date, "MM-dd-yyyy").toJSDate() : now.plus({days: 1}).toJSDate(),
      noEarlierTime: '11:00',
      noLaterDate: this.date ? LuxonDateTime.fromFormat(this.date, "MM-dd-yyyy").toJSDate() : now.plus({days: 1}).toJSDate(),
      noLaterTime: '11:00',
    });
  }

  async selectInitialProAndTab() {
    const selectedTab = this.navCtrl.getParam('selectedTab') || this.dialogParams?.selectedTab;
    const selectedPro = this.navCtrl.getParam('selectedPro') || this.dialogParams?.selectedPro;
    // The reschedule prefill already picked the job's pro, so don't replace it with a default.
    const keepsReschedulePro = this.isRescheduling && this.originalJobData?.originalPro && this.form.value.pro === this.originalJobData.originalPro;
    if (keepsReschedulePro) {
      this.addAllProsToProItems();
    } else if (selectedTab) {
      this.selectedTab = selectedTab;
      await this.addAllProsToProItems();
      return this.selectTab(selectedTab);
    } else if (selectedPro) {
      this.selectedTab = selectedPro.is_private ? 'assign' : 'request';
      await this.addAllProsToProItems();
      this.form.patchValue({pro: selectedPro.homekeeper.id});
      await this.selectPro(selectedPro.homekeeper.id);
    } else if (!this.hasPrivatePros || this.proItems.length === 1) {
      this.selectedTab = 'request';
      await this.addAllProsToProItems();
      this.form.patchValue({pro: this.proItems[0].value});
      await this.selectPro(this.proItems[0].value);
    } else {
      this.selectedTab = 'assign';
      await this.addAllProsToProItems();
      const proId = this.getAndPatchFirstFeasiblePro();
      if (proId) {await this.selectPro(proId);}
    }
    this.showProChangeLoader = false;
  }

  getAndPatchFirstFeasiblePro() {
    const feasiblePro = this.proItems.find((pro) => pro?.addressHomekeeperPriorities?.some((addressHomekeeperPriority) =>
      addressHomekeeperPriority.address_id === this.form.value.address && addressHomekeeperPriority.service_type_id === this.form.value.serviceType
    ));
    if (feasiblePro) {this.form.patchValue({pro: feasiblePro.value});}
    return feasiblePro?.value;
  }

  async changePro(proId) {
    await this.selectPro(proId);
    this.showProChangeLoader = false;
  }

  async selectPro(proId) {
    this.showProChangeLoader = true;
    this.unableToRequestJob = false;
    this.selectedPro = null;
    const selectedPro = this.proItems.find((pro) => pro.value === proId);
    if (proId === 'add_pro') {
      return;
    } else if (proId === 'all_my_pros') {
      this.form.patchValue({
        frequency: 'once'
      });
      await this.getPriorityListSentence();
    } else {
      let canBookWithPro = false;
      selectedPro.addressHomekeeperPriorities.map((addressHomekeeperPriority) => {
        if (addressHomekeeperPriority.address_id === this.form.value.address && addressHomekeeperPriority.service_type_id === this.form.value.serviceType) {
          canBookWithPro = true;
        }
      });
      if (!canBookWithPro) {
        return this.showAddCurrentProModal(selectedPro);
      }
    }
    this.selectedPro = selectedPro;
    this.proServiceItems = [];
      if (this.selectedPro?.isPrivate) {
        this.services = await this.bookJobService.fetchTeamServices(proId, this.form.value.serviceType);
      } else {
        const didSelectPro = proId !== 'all_my_pros';
        this.services = await this.bookJobService.fetchRequiredTeamServices(proId, didSelectPro, this.form.value.serviceType);
        this.services = this.services.filter(service => !service.key.includes('turnover'));
      }
      this.services.map((service) => {
        this.proServiceItems.push({
          value: service.key,
          viewValue: new TranslationPipe().transform(service.title)
        });
      });
      this.form.patchValue({
        service: this.proServiceItems[0]?.value
      });
    this.changeDetectorRef.detectChanges();
    if (this.selectedTab === 'request' && this.form.value.pro !== 'all_my_pros' && this.form.value.pro !== 'add_pro') {
      this.loadAvailabilityRequestTimeItems(this.selectedPro);
    }
    if (proId === 'all_my_pros') {
      await this.markAllTimesSelected();
    }
    if (proId === this.originalJobData?.originalPro) {
      return;
    }
    this.selectedService = this.services.find((service) => service.key === this.form.value.service);
  }

  showAddProForm() {
    this.form.patchValue({pro: 'add_pro'});
    this.changePro('add_pro');
  }

  async turnOnFindNewPros() {
    await this.prosService.moveProToCollection(this.form.value.address, parseInt(this.form.value.serviceType), true);
    await this.onboardingProvider.markGoalAsCompleted('selectFindNewPros');
    this.onboardingProvider.setShowOnboardingInHeader(true);
    this.changePro('all_my_pros');
    this.util.showSuccess(`Find new pros for ${this.selectedServiceType.viewValue.toLowerCase()} workflow at ${this.selectedAddress.address_name ? this.selectedAddress.address_name : this.selectedAddress.address1} turned on`);
  }

  async showAddCurrentProModal(selectedPro) {
    const propertyName = this.selectedAddress.address_name ? this.selectedAddress.address_name : this.selectedAddress.address1;
    const params: ConfirmPageParamsModel = {
      title: `${new TranslationPipe().transform('Add')  } ${  selectedPro?.viewValue } ${  new TranslationPipe().transform('to')  } ${  this.selectedServiceType.viewValue  } ${  new TranslationPipe().transform('Workflow')  }?`,
      customBackAction: this.confirmDontAddCurrentPro.bind(this),
      body: `${selectedPro?.viewValue  } ${  new TranslationPipe().transform('is not added to your')  } ${  this.selectedServiceType.viewValue.toLowerCase()  } ${  new TranslationPipe().transform('workflow')  } at ${  propertyName  }. ${  new TranslationPipe().transform('Would you like to add them')  }?`,
      backText: 'No',
      confirmText: 'Add Pro',
      confirmAction: this.confirmAddCurrentPro.bind(this),
    };
    const confirmationModal = await this.modalCtrl.create({
      component: ConfirmPage,
      componentProps: params,
      animated: false,
      cssClass: 'confirm-modal',
    });
    confirmationModal.onDidDismiss().then(() => this.modalCtrl.dismiss());
    await confirmationModal.present();
  }

  async confirmDontAddCurrentPro() {
    const proId = this.getAndPatchFirstFeasiblePro();
    if (proId) {
      await this.selectPro(proId);
      this.showProChangeLoader = false;
    } else {
      this.form.patchValue({pro: null});
    }
    this.modalCtrl.dismiss();
  }

  async confirmAddCurrentPro() {
    try {
      const payload = {
        service_type_id: this.form.value.serviceType,
        homekeeper_ids: [this.form.value.pro]
      };
      await this.prosService.addExistingPros(payload, this.form.value.address);
      // Cache invalidation now handled by Pros service via TanStack Query
      await this.getProItems();
      await this.addAllProsToProItems();
      await this.selectPro(this.form.value.pro);
      await this.getBookingForm();
      this.showProChangeLoader = false;
      this.modalCtrl.dismiss();
    } catch (err) {
      this.util.showError((err.error && err.error.message) ? err.error.message : err.message);
    }
  }

  async addNewPro() {
    this.submitted = true;
    if (!this.form.valid) {
      return;
    }
    this.submitted = false;
    try {
      const params = {
        name: this.form.value.newProName,
        email: this.form.value.newProEmail,
        phone: parsePhoneNumber(this.countryCode + this.form.value.newProPhone),
        add_to_address_homekeeper_list: {
          address_ids: [this.form.value.address],
          service_type_ids: [this.form.value.serviceType]
        }
      };
      if (!this.form.value.phone) {
        delete params.phone;
      }
      const pro = await this.prosService.addNewPro(params);
      await this.onboardingProvider.markGoalAsCompleted('addPros');
      // Cache invalidation now handled by Pros service via TanStack Query
      await this.storage.save('shouldReloadAllAutomations', true);
      await this.getProItems();
      await this.addAllProsToProItems();
      this.form.patchValue({pro: pro.id});
      await this.selectPro(pro.id);
      this.showProChangeLoader = false;
    } catch (err) {
      this.util.showError((err.error && err.error.message) ? err.error.message : err.message);
    }
  }

  async getProItems() {
    this.proItems = [];
    this.prosData = await this.prosService.getAllPros();
    this.prosData.map((pro) => {
      this.proItems.push({
        value: pro.id,
        viewValue: `${pro.first_name  } ${  pro.last_name}`,
        isPrivate: pro.is_private,
        addressHomekeeperPriorities: pro.address_homekeeper_priorities
      });
    });
    this.proItems.push({
      viewValue: `+ ${  new TranslationPipe().transform('Add pro')}`,
      value: 'add_pro'
    });
  }

  addAllProsToProItems() {
    if (this.selectedTab === 'assign') {
      this.proItems = this.proItems.filter(item => item.value !== 'all_my_pros');
    } else {
      this.proItems.unshift({
        viewValue: 'Pro Search Agent',
        value: 'all_my_pros'
      });
    }
  }

  async selectTab(tabValue: string) {
    this.showProChangeLoader = true;
    this.unableToRequestJob = false;
    this.selectedPro = null;
    this.selectedTab = tabValue;
    if (tabValue === 'request') {
      this.proItems.unshift({
        viewValue: 'Pro Search Agent',
        value: 'all_my_pros'
      });
      this.form.patchValue({ pro: 'all_my_pros' });
      await this.selectPro('all_my_pros');
      this.frequencyItems = this.frequencyItems.filter(item =>
        item.value !== 'twice_a_week' && item.value !== 'thrice_a_week'
      );
    } else {
      this.proItems = this.proItems.filter(item => item.value !== 'all_my_pros');
      this.frequencyItems = this.allFrequencyItems;
      this.form.controls.frequency.enable();
      if (!this.form.value.frequency || !this.frequencyItems.find(f => f.value === this.form.value.frequency)) {
        this.form.patchValue({ frequency: 'once' });
      }
      const proId = this.getAndPatchFirstFeasiblePro();
      if (proId) {
        await this.selectPro(proId);
      } else {
        this.form.patchValue({pro: null});
      }
    }
    if (tabValue === 'request') {
      await this.markAllTimesSelected();
      // Track initiate_checkout for rentals when they switch to request tab
      await this.trackInitiateCheckoutForRentals();
    }
    await this.getBookingForm();
    this.showProChangeLoader = false;
  }

  async getBookingForm() {
    const serviceTypeName = this.selectedServiceType?.name;
    if (serviceTypeName !== 'Cleaning' && serviceTypeName !== 'Regular Cleaning') {
      this.forms = await this.bookJobService.getBookingFormTemplate(this.form.value.service);
    } else {
      this.forms = null;
    }
  }

  async changeAddress() {
    this.showLoader = true;
    this.unableToRequestJob = false;
    localStorage.setItem('addressId', this.form.value.address);
    const address = this.addresses.find((addr) => addr.id === this.form.value.address);
    this.selectedAddress = address;
    this.currentDateTime = LuxonDateTime.fromObject({}, {
      zone: this.selectedAddress.timezone,
    });
    let proId = this.getAndPatchFirstFeasiblePro();
    if (this.selectedTab === 'request') {
      await this.getPriorityListSentence();
      if (!proId) {
        proId = 'all_my_pros';
        this.form.patchValue({pro: proId});
      }
    }
    if (proId) {
      await this.selectPro(proId);
    } else {
      this.selectedPro = null;
      this.form.patchValue({pro: null});
    }
    this.showProChangeLoader = false;
    this.showLoader = false;
  }


  async changeServiceType() {
    this.showLoader = true;
    this.unableToRequestJob = false;
    const serviceType = this.serviceTypeItems.find((st) => st.value === this.form.value.serviceType);
    this.selectedServiceType = serviceType;
    let proId = this.getAndPatchFirstFeasiblePro();
    if (this.selectedTab === 'request') {
      await this.getPriorityListSentence();
      if (!proId) {
        proId = 'all_my_pros';
        this.form.patchValue({pro: proId});
      }
    }
    if (proId) {
      await this.selectPro(proId);
    } else {
      this.selectedPro = null;
      this.form.patchValue({pro: null});
    }
    if (this.proItems.length > 0) {
      await this.getBookingForm();
    }
    this.showProChangeLoader = false;
    this.showLoader = false;
  }

  async getPriorityListSentence() {
    const priorityListData = await this.prosService.getPros(this.form.value.serviceType, this.form.value.address);
    const parsedProsData = this.prosService.parseProsIntoGroups(priorityListData);
    this.unableToRequestJob = ![...parsedProsData?.favorited, ...parsedProsData?.approved].length;
    this.priorityListSentence = this.prosService.updatePriorityListSentence(parsedProsData);
  }

  async changeService() {
    this.showServiceChangeLoader = true;
    this.selectedService = this.services.find((service) => service.key === this.form.value.service);
    await this.getBookingForm();
    this.showServiceChangeLoader = false;
  }

  async saveJobNotesToNewBooking() {
    if (!this.newBookingId) {
      return;
    }
    const jobNoteText = this.form.value.jobNote;
    if (jobNoteText && jobNoteText.trim() !== '') {
      const payload = {
        booking_id: this.newBookingId,
        type: 'text',
        text: jobNoteText.trim(),
      };
      await this.schedule.createJobNote(payload);
    }
  }

  onAttachmentsChange(attachments: any[]) {
    this.attachments = attachments;
  }

  onSelectedCheckboxesChange(selectedCheckboxes: any[]) {
    this.selectedCheckboxes = selectedCheckboxes;
  }

  onFormDataChange(event: any) {
    switch (event.type) {
      case 'componentInitialized':
        if (event.isReady && this.isRescheduling && this.originalJobData?.originalBookingId) {
          this.loadOriginalDataIfNeeded();
        }
        break;
      case 'formsLoaded':
        if (this.isRescheduling && this.originalJobData?.originalBookingId) {
          this.loadOriginalDataIfNeeded();
        }
        break;
      case 'externalDataLoaded':
        break;
    }
  }

  private async waitForDynamicFormReady(): Promise<void> {
    if (this.dynamicBookingForm) {
      await this.dynamicBookingForm.waitForReady();
    }
  }

  private async loadOriginalDataIfNeeded(): Promise<void> {
    if (this.isRescheduling && this.originalJobData?.originalBookingId) {
      await this.loadOriginalBookingFormData();
    }
  }

  async handleReschedulingPreFill() {
    try {
      const originalData = this.originalJobData;
      if (originalData.originalAddress && originalData.originalAddress !== this.form.value.address) {
        this.form.patchValue({ address: originalData.originalAddress });
        await this.changeAddress();
      }
      if (originalData.serviceType) {
        this.form.patchValue({ serviceType: originalData.serviceType });
        const _serviceType = this.serviceTypeItems.find(
          (st) => st.value === originalData.serviceType
        );
      }
      if (originalData.originalPro && this.proItems?.length) {
        const matchingPro = this.proItems.find(
          (pro) => pro.value === originalData.originalPro
        );
        if (matchingPro) {
          this.selectedTab = matchingPro.isPrivate ? 'assign' : 'request';
          this.form.patchValue({ pro: originalData.originalPro });
          await this.selectPro(originalData.originalPro);
          this.showProChangeLoader = false;
          if (originalData.serviceKey && this.proServiceItems?.length) {
            const matchingService = this.proServiceItems.find(
              (service) => service.value === originalData.serviceKey
            );
            if (matchingService) {
              this.form.patchValue({ service: originalData.serviceKey });
              this.selectedService = this.services.find((service) => service.key === originalData.serviceKey);
            }
          }
        }
      }
      if (originalData.originalDate) {
        const originalDate = LuxonDateTime.fromISO(originalData.originalDate, { setZone: true });
        const formattedDate = originalDate.toFormat('yyyy-MM-dd');
        if (this.form.contains('jobDate')) {
          this.form.patchValue({ jobDate: formattedDate });
        }
      }
      if (originalData.originalTime) {
        let timeValue = originalData.originalTime;
        if (typeof timeValue === 'string' && timeValue.includes('T')) {
          const timeDate = LuxonDateTime.fromISO(timeValue, { zone: 'utc' });
          timeValue = timeDate.toFormat('HH:mm');
        }
        if (this.form.contains('jobTime')) {
          this.form.patchValue({ jobTime: timeValue });
        }
      }
      await this.loadOriginalJobNotes();
      await this.loadOriginalBookingFormData();
      await this.waitForDynamicFormReady();
    } catch (err) {
      this.util.showError((err.error && err.error.message) ? err.error.message : err.message);
    }
  }

  async loadOriginalJobNotes() {
    try {
      if (this.originalJobData?.originalJobNotes?.length > 0) {
        const textNote = this.originalJobData.originalJobNotes.find(
          (note) => note.type === 'text'
        );
        if (textNote) {
          this.form.patchValue({ jobNote: textNote.text });
          return;
        }
      }
      if (this.originalJobData?.originalBookingId) {
        const originalNotes = await this.schedule.getBookingNotesForJob(
          this.originalJobData.originalBookingId
        );
        if (originalNotes && originalNotes.length > 0) {
          const textNote = originalNotes.find((note) => note.type === 'text');
          if (textNote) {
            this.form.patchValue({ jobNote: textNote.text });
          }
        }
      }
    } catch (err) {
      this.util.showError((err.error && err.error.message) ? err.error.message : err.message);
    }
  }

  async loadOriginalBookingFormData() {
    if (this.originalJobData?.originalBookingId) {
    if (!this.forms || !this.forms[0] || !this.forms[0].inputs) {
      const serviceKey = this.originalJobData.serviceKey;
      if (serviceKey) {
        await this.getBookingForm();
      } else {
        return;
      }
    }
    const originalFormAnswers =
      await this.schedule.getJobBookingFormAnswers(
        this.originalJobData.originalBookingId
      );
      if (originalFormAnswers && originalFormAnswers.length > 0) {
        await this.waitForDynamicFormReady();
        if (this.dynamicBookingForm) {
          await this.dynamicBookingForm.safeLoadExternalData(originalFormAnswers);
        }
      }
    }
  }

  closePage() {
    if (this.windowService.isDesktopRes) {
      this.rightSidePanelService.closeRightSidePanel();
    } else {
      const shouldShowAllToDosPage = localStorage.getItem('shouldShowAllToDosPage') === 'true';
      this.navCtrl.navigateForward(shouldShowAllToDosPage || this.windowService.isDesktopRes ? 'schedule' : 'schedule-list');
    }
  }

  getButtonText() {
    if (this.isRescheduling) {
      return 'Reschedule Job';
    } else if (this.bookingType === 'reschedule_job') {
      return 'Reschedule';
    } else if (this.bookingType === 'reschedule_plan') {
      return 'Reschedule Plan';
    } else if (this.selectedTab === 'assign') {
      return 'Assign Pro';
    } else {
      return 'Send Job Request';
    }
  }

  async addPro() {
    this.isAddingPro = true;
    this.submitted = true;
    if (!this.addProForm.valid) {
      return;
    }
    try {
      const params = {
        name: this.addProForm.value.name,
        email: this.addProForm.value.email,
        phone: parsePhoneNumber(this.countryCode + this.addProForm.value.phone),
        add_to_address_homekeeper_list: {
          address_ids: [this.form.value.address],
          service_type_ids: this.addProForm.value.serviceCategories
        }
      };
      if (!this.addProForm.value.phone) {
        delete params.phone;
      }
      await this.prosService.addNewPro(params);
      await this.onboardingProvider.markGoalAsCompleted('addPros');
      localStorage.setItem('hasPrivatePro', 'true');
      await this.getProItems();
      await this.addAllProsToProItems();
      await this.selectPro(this.proItems[0].value);
      await this.getBookingForm();
      await this.storage.save('shouldReloadAllAutomations', true);
      this.showProChangeLoader = false;
      this.isAddingPro = false;
      this.submitted = false;
    } catch (err) {
      this.util.showError((err.error && err.error.message) ? err.error.message : err.message);
    }
  }

  showIssueLoadingPageAlert() {
    const shouldShowAllToDosPage = localStorage.getItem('shouldShowAllToDosPage') === 'true';
    this.storage.save('shouldReloadSchedule', 'true');
    const params = {
      header: 'Issue Accessing Page',
      body: 'Please try again from your Schedule and the issue should be resolved.  Thanks for your patience.',
      buttonText: 'Go to Schedule',
      buttonRoute: shouldShowAllToDosPage || this.windowService.isDesktopRes ? 'schedule' : 'schedule-list'
    };
    this.rightSidePanelService.navigateTo('success', params);
    this.rightSidePanelService.setDialogLoading(false);
  }

  selectFrequency(frequency) {
    this.selectedFrequency = frequency;
    const t = (key: string) => new TranslationPipe().transform(key);
    if (frequency === 'thrice_a_week' || frequency === 'twice_a_week') {
      this.firstJobDateLabel = t('First job date');
      this.firstJobTimeLabel = t('First job time');
      const jobDate = LuxonDateTime.fromISO(this.form.value.jobDate);
      this.form.patchValue({
        jobSecondDate: jobDate.plus({ days: 2 }).toISODate(),
        jobThirdDate: jobDate.plus({ days: 4 }).toISODate()
      });
    } else if (frequency === 'every_day') {
      this.firstJobDateLabel = t('Start date');
      this.firstJobTimeLabel = t('Job time');
    } else {
      this.firstJobDateLabel = t('Job date');
      this.firstJobTimeLabel = t('Job time');
    }
  }

  async submitForm() {
    try {
      const date = LuxonDateTime.fromISO(this.form.value.jobDate).toISO();
      this.submitted = true;
      this.hasImageUploadError = false;
      const payload = this.buildJobPayload();
      const bookingFormData = this.dynamicBookingForm?.buildBookingFormData() || { input_answers: [] };
      if (bookingFormData && bookingFormData.input_answers.length > 0) {
        payload['booking_form'] = bookingFormData;
      }
      if (this.dynamicBookingForm && this.dynamicBookingForm?.forms && !this.dynamicBookingForm.validateRequiredFields()) {
        return this.util.showError('Please fill out all required fields before submitting.');
      }
      if (this.hasImageUploadError) {
        return this.util.showError('Please upload all required images before submitting.');
      }
      if (this.selectedTab === 'request' && this.form.value.pro !== 'all_my_pros') {
        if (this.selectedTimes.length === 0) {
          return this.util.showError('Please select at least one time.');
        }
        const hasInvalidTimeRanges = this.timeRangeForms?.some(dayForms =>
          dayForms?.some(formGroup => formGroup.invalid)
        );
        if (hasInvalidTimeRanges) {
          return this.util.showError('One or more time ranges cannot fit the length of the job.');
        }
      }

      // Credit card check before job request
      let storedHasCard = localStorage.getItem('hasCard');
      if (!storedHasCard) {
        storedHasCard = await this.card.hasValidCard().then((hasCard) => hasCard ? 'true' : 'false');
      }
      const hasCard = storedHasCard === 'true';
      if (this.selectedTab === 'request' && !hasCard) {
        const pendingAction = {
          type: 'job-request',
          payload: {
            requestType: this.form.value.pro === 'all_my_pros' ? 'all_my_pros' : 'pro_request',
            bookingType: this.form.value.frequency === 'once' ? 'add_one_time_job' : 'add_job',
            jobPayload: payload,
            addressId: this.form.value.address,
            jobNote: this.form.value.jobNote,
            frequency: this.form.value.frequency
          },
          successMessage: 'Job request sent',
          successRoute: 'schedule'
        };
        await this.storage.save('autopilot-pending-action', pendingAction);
        this.rightSidePanelService.navigateTo('add-credit-card-to-book', {}, AddCreditCardToBookComponent);
        return;
      }

      this.schedule.addSkeletonJobToCalendar(date, this.form.value.jobTime, this.form.value.address);
      if (this.isRescheduling && this.originalJobData) {
        if (this.originalJobData.originalPlanId && this.bookingType === 'reschedule_plan') {
          await this.schedule.cancelPlan(this.originalJobData.originalPlanId);
        } else if (this.originalJobData.originalBookingId) {
          await this.schedule.cancelJob(this.originalJobData.originalBookingId);
        }
      } else if (this.bookingType === 'reschedule_job') {
        await this.schedule.cancelJob(this.bookingId);
      } else if (this.bookingType === 'reschedule_plan') {
        await this.schedule.cancelPlan(this.planId);
      }
      if (this.selectedTab === 'assign') {
        const bookingType = this.form.value.frequency === 'once' ? 'add_one_time_job' : 'add_job';
        const result = await this.bookJobService.saveJob(bookingType, payload, null, null);
        this.newBookingId = result?.booking_id || result?.id;
      } else if (this.selectedTab === 'request' && this.form.value.pro === 'all_my_pros') {
        if (this.form.value.frequency !== 'once') {
          const result = await this.bookJobService.saveJob('add_job', payload, null, null);
          this.newBookingId = result?.booking_id || result?.id;
        } else {
          const result = await this.requests.addJobRequest(this.form.value.address, payload);
          this.newBookingId = result?.booking_id || result?.id;
        }
      } else {
        const result = await this.requests.addProRequest(this.form.value.address, payload);
        this.newBookingId = result?.booking_id || result?.id;
      }
      if (this.form.value.frequency === 'once' && this.form.value.jobNote) {
        await this.saveJobNotesToNewBooking();
      }
      localStorage.setItem('madeUpdateToSchedule', 'true');
      localStorage.setItem('didBookJob', 'true');
      this.storage.delete('moreDetailAddresses');
      this.closePage();
      let successMessage = 'Job added';
      if (this.isRescheduling) {
        successMessage = 'Job rescheduled';
      }
      this.util.showSuccess(successMessage);
      this.schedule.removeSkeletonJobFromCalendar();
    } catch (err) {
      this.schedule.removeSkeletonJobFromCalendar();
      this.util.showError((err.error && err.error.message) ? err.error.message : err.message);
    }
  }

  buildJobPayload() {
    if (this.form.value.pro === 'all_my_pros') {
      if (this.form.value.frequency !== 'once') {
        //RECURRING PLAN WITH TIME WINDOW
        return {
          address_id: this.form.value.address,
          frequency: this.form.value.frequency,
          service_type_key: this.form.value.service,
          dates: [{
            start_date_no_earlier_than: this.formatDateForAPI(this.form.value.noEarlierDate),
            start_time_no_earlier_than: this.form.value.noEarlierTime,
            end_date_no_later_than: this.formatDateForAPI(this.form.value.noLaterDate),
            end_time_no_later_than: this.form.value.noLaterTime,
            homekeeper_ids: []
          }],
          hk_rating: 'same_day',
          rating_chosen: false,
          backup_times_blocks: []
        }
      }
      //JOB REQUEST
      return {
        address_id: this.form.value.address,
        booking: {
          request_type: 'waterfall',
          service_type_key: this.form.value.service,
          start_date_no_earlier_than: this.formatDateForAPI(this.form.value.noEarlierDate),
          start_time_no_earlier_than: this.form.value.noEarlierTime,
          end_date_no_later_than: this.formatDateForAPI(this.form.value.noLaterDate),
          end_time_no_later_than: this.form.value.noLaterTime,
        },
        rating_options:{
          hk_rating: 'same_day',
          rating_chosen: false
        },
      }
    } else if (this.selectedTab === 'request') {
      //PRO REQUEST
      return {
        address_id: this.form.value.address,
        frequency: this.form.value.frequency,
        homekeeper_id: this.form.value.pro,
        service_type_key: this.form.value.service,
        request_time_blocks: this.selectedTimes
      }
    } else if (this.form.value.frequency === 'once') {
      //ASSIGN JOB
      return {
        address_id: this.form.value.address,
        booking: {
            service_type_key: this.form.value.service,
            preferred_start_date: this.form.value.jobDate,
            preferred_start_time: this.form.value.jobTime,
        },
        rating_options:{
          hk_rating: 'specific_hk',
          rating_chosen: false
        },
        homekeeper_ids: [
          this.form.value.pro
        ],
        backup_times_blocks: []
      }
    } else {
      //ASSIGN JOB
      const response: any = {
        address_id: this.form.value.address,
        frequency: this.form.value.frequency,
        dates: [{
          date: this.form.value.jobDate,
          time: this.form.value.jobTime,
          homekeeper_ids: [
            this.form.value.pro
          ]
        }],
        service_type_key: this.form.value.service,
        hk_rating: 'specific_hk',
        rating_chosen: false,
        backup_times_blocks: []
      }
      if (this.form.value.frequency === 'twice_a_week' || this.form.value.frequency === 'thrice_a_week') {
        response.dates.push({
          date: this.form.value.jobSecondDate,
          time: this.form.value.jobSecondTime,
          homekeeper_ids: [
            this.form.value.pro
          ]
        })
      }
      if (this.form.value.frequency === 'thrice_a_week') {
        response.dates.push({
          date: this.form.value.jobThirdDate,
          time: this.form.value.jobThirdTime,
          homekeeper_ids: [
            this.form.value.pro
          ]
        })
      }
      return response;
    }
  }

  //JOB REQUEST METHODS

  goToLearnMoreProbability() {
    const url = 'https://help.tidy.com/acceptance-probability';
    this.util.openUrl(url);
  }

  buildRequestJobTimes() {
    let numberOfOptions = 10;
    let noLaterStart = 9;
    if (this.isRentalClient || this.hasPrivatePros) {
      this.allTimesOpts = this.timeRanges.timeRangesOpts();
      this.noEarlierTimes = this.timeRanges.timeRangesOpts();
      this.noLaterTimes = this.timeRanges.timeRangesOpts();
    } else {
      if (this.selectedService.duration === 150) {
        numberOfOptions = 9;
        noLaterStart = 11;
      } else if (this.selectedService.duration === 240) {
        numberOfOptions = 8;
        noLaterStart = 13;
      }
      this.allTimesOpts = this.buildTimesArray(8, 11);
      this.noEarlierTimes = this.buildTimesArray(8, numberOfOptions);
      this.noLaterTimes = this.timeRanges.timeRangesOpts().filter(timeOpt => !(timeOpt.value < noLaterStart?.toString()
                || timeOpt.value > '23:00'));
    }
    this.form.patchValue({
      noEarlierTime: '08:00',
      noLaterTime: '18:30'
    });
  }

  earlierDateChange(event) {
    if (!event || event === '') {
      return;
    }
    this.tooFarStartDateError = false;
    this.showSameDayTimeAlert = LuxonDateTime.fromJSDate(this.form.value.noEarlierDate).hasSame(this.currentDateTime, 'day');
    if (this.showSameDayTimeAlert) {
      this.noEarlierTimes = this.allTimesOpts.filter(timeOpt => {
        const timeOptOnZone = LuxonDateTime
          .fromFormat(timeOpt.value, 'HH:mm', {zone: this.selectedAddress.timezone});
        const minutesDiff = timeOptOnZone
          .diff(this.currentDateTime, 'minutes')
          .toObject().minutes;
        return minutesDiff > 10;
      });
    } else {
      this.noEarlierTimes = this.allTimesOpts;
    }
    const serviceDuration = this.services.find((service) => service.key === this.form.value.service).duration;
    this.noEarlierTimes = this.noEarlierTimes.filter(timeOpt => {
      const serviceEndTime = LuxonDateTime.fromFormat(timeOpt.value, 'HH:mm').plus({ minutes: serviceDuration });
      const lastTimeOpt = LuxonDateTime.fromFormat('23:00', 'HH:mm');
      return serviceEndTime.diff(lastTimeOpt, 'minutes').minutes <= 0;
    });
    this.markAllTimesSelected();
  }

  selectNoEarlierTime(time) {
    if (this.form.value.noLaterDate < this.form.value.noEarlierDate
        || (this.form.value.noLaterDate <= this.form.value.noEarlierDate && time > this.form.value.noLaterTime)) {
      this.form.patchValue({noLaterTime: null});
    }
    this.showSameDayTimeAlert = LuxonDateTime.fromJSDate(this.form.controls.noEarlierDate.value).hasSame(this.currentDateTime, 'day');
    this.updateNoLaterOpts();
    this.markAllTimesSelected();
  }

  updateNoLaterOpts() {
    this.showTimesError = false;
    const noEarlierDate = this.form.value.noEarlierDate;
    const noLaterDate = this.form.value.noLaterDate;
    this.markAllTimesSelected();
    if (noEarlierDate && noLaterDate) {
      if (this.isRentalClient || this.hasPrivatePros) {
        if (this.isIssueWithSelectedTimes()) {
          this.timesErrorText = this.getTimesErrorText();
          return this.showTimesError = true;
        } else {
          return;
        }
      }
      if ((noEarlierDate.toString() === noLaterDate.toString())) {
        const serviceDuration = this.services.find((service) => service.key === this.form.value.service).duration;
        const serviceEnd = LuxonDateTime.fromFormat(this.form.value.noEarlierTime, 'HH:mm').plus({ minutes: serviceDuration });
        this.noLaterTimes = this.timeRanges.timeRangesOpts().filter(timeOpt => {
          const optionDateTime = LuxonDateTime.fromFormat(timeOpt.value, 'HH:mm');
          return !(optionDateTime.diff(serviceEnd).as('milliseconds') < 0
                  || timeOpt.value > '23:00');
        });
      } else {
        this.noLaterTimes = this.buildTimesArray(7, 33);
      }
    } else {
      return;
    }
  }

  buildTimesArray(startHour, numberOfOptions) {
    const minutesBetweenEachOption = 90;
    return Array.from({ length: numberOfOptions }, (_, index) => {
      const luxonDateTimeObject = LuxonDateTime.local().set({ hour: startHour, minute: 0, second: 0 }).plus({ minutes: index * minutesBetweenEachOption });
      const hour12Format = luxonDateTimeObject.toFormat('h:mma');
      const militaryHourFormat = luxonDateTimeObject.toFormat('HH:mm');
      return { viewValue: hour12Format, value: militaryHourFormat };
    });
  }

  async markAllTimesSelected() {
    this.didSelectAllTimes = this.form.value.noEarlierDate && this.form.value.noEarlierTime && this.form.value.noLaterDate && this.form.value.noLaterTime;
    const hasFindNewProsOn = this.priorityListSentence.includes('new pros');
    if (this.didSelectAllTimes && hasFindNewProsOn) {
      const bookData = this.getJobRequestBookData();
      this.probabilityData = await this.bookJobService.getRequestProbability(bookData, this.form.value.address);
    } else {
      this.probabilityData = null;
    }
  }

  getJobRequestBookData() {
    return {
      address_id: this.form.value.address,
      booking: {
        service_type_key: this.form.value.service,
        start_date_no_earlier_than: this.formatDateForAPI(this.form.value.noEarlierDate),
        start_time_no_earlier_than: this.form.value.noEarlierTime,
        end_date_no_later_than: this.formatDateForAPI(this.form.value.noLaterDate),
        end_time_no_later_than: this.form.value.noLaterTime,
        request_type: 'waterfall'
      },
      rating_options: {hk_rating: 'same_day', rating_chosen: false},
      booking_form: {
        input_answers: this.buildBookingFormAnswers()
      },
      attachments: this.attachments,
      selectedCheckboxes: this.selectedCheckboxes
    };
  }

  private buildBookingFormAnswers() {
    if (this.dynamicBookingForm && this.dynamicBookingForm.isReady) {
      const formData = this.dynamicBookingForm.buildBookingFormData();
      return formData?.input_answers || [];
    }
    return [];
  }

  isIssueWithSelectedTimes() {
    const startIndex = this.timeRanges.timeRangesOpts().findIndex(item => item.value === this.form.value.noEarlierTime);
    const endIndex = this.timeRanges.timeRangesOpts().findIndex(item => item.value === this.form.value.noLaterTime);
    const numberOfItemsBetween = endIndex - startIndex - 1;
    const serviceDuration = this.services.find((service) => service.key === this.form.value.service).duration;
    if (startIndex < 16 || endIndex > 46) {
      return true;
    } else if (serviceDuration === 240 && (numberOfItemsBetween < 10)) {
      return true;
    } else if (serviceDuration === 150 && (numberOfItemsBetween < 7)) {
      return true;
    } else if (numberOfItemsBetween < 4) {
      return true;
    } else {
      return false;
    }
  }

  selectNoLaterTime(time) {
    this.showTimesError = false;
    if (this.isRentalClient || this.hasPrivatePros) {
      if (this.isIssueWithSelectedTimes()) {
        this.timesErrorText = this.getTimesErrorText();
        return this.showTimesError = true;
      }
    }
    if (this.form.value.noLaterDate < this.form.value.noEarlierDate || (this.form.value.noLaterDate <= this.form.value.noEarlierDate && time < this.form.value.noEarlierTime)) {
      this.form.patchValue({noEarlierTime: null});
    }
    this.showSameDayTimeAlert = LuxonDateTime.fromJSDate(this.form.controls.noEarlierDate.value).hasSame(this.currentDateTime, 'day');
    this.markAllTimesSelected();
  }

  getTimesErrorText() {
    if (this.selectedService.duration === 240) {
      return '5.5 hours of time for a 4 hour job.';
    } else if (this.selectedService.duration === 150) {
      return '4 hours of time for a 2.5 hour job.';
    } else {
      return '2.5 hours of time for a 1 hour job.';
    }
  }

  goToJobRequestWorkflows() {
    const address = this.addresses.find((addr) => addr.id === this.form.value.address);
    localStorage.setItem('addressId', address.id.toString());
    localStorage.setItem('selectedCategoryId', this.form.value.serviceType.toString());
    const params = {
      addressId: address.id,
      categoryId: this.form.value.serviceType,
      address
    };
    this.rightSidePanelService.navigateTo('job-request-workflows', params);
  }

  //PRO REQUEST METHODS

  async loadAvailabilityRequestTimeItems(selectedPro) {
    if (selectedPro.isPrivate) {
      this.availabilityRequestTimeItems = this.timeRanges.timeRangesOpts();;
    } else {
      this.availabilityRequestTimeItems = this.timeRanges.tidyJobRangesOpts();
    }
    const currentTime = LuxonDateTime.fromObject({}, {zone: this.selectedAddress.timezone,});
    const _30minAhead = currentTime.plus({minutes: 30}).toFormat('HH:mm');
    this.todayAvailabilityRequesTimeItems = this.availabilityRequestTimeItems.filter(opt => opt.value > _30minAhead);
  }

  markCheckbox(value: boolean, dayIndex: number) {
    if (value) {
      this.addNewTimeRange(dayIndex);
    } else {
      this.timeRangeForms[dayIndex] = [];
    }
    this.updateValuesValidity();
  }

  addNewTimeRange(weekDay: number, index = 0) {
    if (!this.selectedService) {
      return;
    }
    if (!this.timeRangeForms[weekDay]) {
      this.timeRangeForms[weekDay] = [];
    }
    const weekDayForms = this.timeRangeForms[weekDay];
    if (weekDay > 0) {
      this.timeRanges.addNewTimeRange(index, weekDayForms, this.selectedService.duration);
    } else {
      this.timeRanges.addNewTimeRange(index, weekDayForms, this.selectedService.duration, this.todayAvailabilityRequesTimeItems[0].value);
    }
    this.updateValuesValidity();
  }

  updateValuesValidity() {
    this.selectedTimes = this.parseRangesForms();
    this.timeRangeForms.forEach((dayForms, index) => {
      this.weekDayCheckBox[index].patchValue({checked: dayForms.length > 0});
    })
  }

  parseRangesForms() {
    return this.timeRangeForms.map((fgArray, index) => {
      const times = fgArray.map(formGroup => formGroup.value);
      if (times?.length) {
        return {
          date: this.requestableDays[index].date,
          times
        };
      }
    }).filter(elem => elem);
  }

  startTimeChange(formGrp: UntypedFormGroup) {
    const start = formGrp.value.start_time;
    const nextEnd = LuxonDateTime.fromFormat(start, 'HH:mm')
      .plus(Duration.fromObject({minutes: this.selectedService.duration}))
      .toFormat('HH:mm');
    formGrp.patchValue({
      end_time: nextEnd
    })
  }

  removeTimeRange(dayIndex: number, timeRangeIndex: number) {
    this.timeRangeForms[dayIndex].splice(timeRangeIndex, 1);
    this.updateValuesValidity();
  }

  viewMoreDays() {
    this.showAllDays = true;
  }

  get displayedRequestableDays() {
    if (this.showAllDays || !this.requestableDays) {
      return this.requestableDays;
    }
    return this.requestableDays.slice(0, 5);
  }

  endTimes(startTime: string) {
    if (!startTime || !this.selectedService) {return [];}
    const lastTime = this.availabilityRequestTimeItems[this.availabilityRequestTimeItems.length - 1];
    if (this.selectedPro.isPrivate) {
      return this.availabilityRequestTimeItems.filter(opt => opt.value > startTime);
    }
    return this.availabilityRequestTimeItems.filter(opt => {
      const serviceEndDiff = LuxonDateTime.fromFormat(lastTime.value, 'HH:mm')
      .diff(LuxonDateTime.fromFormat(opt.value, 'HH:mm')
      .plus(Duration.fromObject({minutes: this.selectedService.duration})));
    const serviceEnd = LuxonDateTime.fromFormat(startTime, 'HH:mm')
      .plus(Duration.fromObject({minutes: this.selectedService.duration}))
      .toFormat('HH:mm');
      return opt.value >= serviceEnd &&
             serviceEndDiff.minutes >= 0;
    });
  }

  async changeServiceRates() {
    try {
      const payload = await this.buildRateChangePayload();
      await this.addressProvider.changePrices(this.form.value.address, payload);
      this.util.showSuccess('Rates updated!');
      await this.selectPro(this.form.value.pro);
    } catch (err) {
      this.util.showError((err.error && err.error.message) ? err.error.message : err.message);
    }
    this.showProChangeLoader = false;
  }

  async buildRateChangePayload() {
    let noTeamAddressServices = await this.addressProvider.getPriceTable(this.form.value.address);
    noTeamAddressServices = noTeamAddressServices.filter(service => service.billing_type !== 'price_later');
    const payload = {
      new_prices: []
    };
    const selectedNoTeamAddressService = noTeamAddressServices.find((service) => service.name === this.selectedService.title);
    noTeamAddressServices.map((service) => {
      const isTheServiceBeingChanged = service.id === selectedNoTeamAddressService.id;
      if (isTheServiceBeingChanged) {
        payload.new_prices.push({
          no_team_address_service_id: selectedNoTeamAddressService.id,
          price: this.selectedService.prices.lowestPossibleBasePrice
        });
      } else {
        payload.new_prices.push({
          no_team_address_service_id: service.id,
          price: service.prices.base_price
        });
      }
    });
    return payload;
  }

  trackByFn(index, item) {
    return item.value;
  }

  onCountryCodeChange(countryCode: string) {
    this.countryCode = countryCode.replace('+', '');
  }

  private formatDateForAPI(dateValue: any): string {
    if (!dateValue) {
      return '';
    }
    if (typeof dateValue === 'string' && dateValue.match(/^\d{4}-\d{2}-\d{2}$/)) {
      return dateValue;
    }
    if (LuxonDateTime.isDateTime(dateValue)) {
      if (dateValue.isValid) {
        return dateValue.toFormat('yyyy-MM-dd');
      }
      console.error('Invalid Luxon DateTime object:', dateValue);
      return '';
    }
    if (dateValue instanceof Date) {
      const luxonDate = LuxonDateTime.fromJSDate(dateValue);
      if (luxonDate.isValid) {
        return luxonDate.toFormat('yyyy-MM-dd');
      }
      console.error('Invalid Date object:', dateValue);
      return '';
    }
    if (typeof dateValue === 'string') {
      const luxonDate = LuxonDateTime.fromISO(dateValue);
      if (luxonDate.isValid) {
        return luxonDate.toFormat('yyyy-MM-dd');
      }
      console.error('Invalid date string:', dateValue);
      return '';
    }
    try {
      const luxonDate = LuxonDateTime.fromJSDate(new Date(dateValue));
      if (luxonDate.isValid) {
        return luxonDate.toFormat('yyyy-MM-dd');
      }
    } catch (e) {
      console.error('Error formatting date for API:', e, dateValue);
    }
    return '';
  }

}
